<script lang="ts">
	import { _ } from 'utils/i18/i18n';

	export let title = $_('learn.title');
	export let dark = false;
	export let fixedMargin = false;
</script>

<section class="titles-wrapper" class:dark class:fixed-margin={fixedMargin}>
	<h1 class="page-title">{title}</h1>
	<h2 class="page-subtitle">
		{$_('learn.subtitle1')}
		<br />
		{$_('learn.subtitle2')}
	</h2>
</section>

<style lang="scss">
	@import 'pageTitle';
</style>
